<template>
  <div>
    <v-card max-width="90%" class="mt-12 mx-auto">
      <v-card-title class="title-center" style="color: #3f51b5;">
        <i class="ml-8 mr-2 fa fa-user" />Edit Profile
      </v-card-title>
      <div class="form-inline">
        <v-text-field
          class="ml-12 mr-12"
          value="Thomas"
          label="Fist Name"
          prepend-inner-icon="mdi-account-edit"
          type="text"
          v-model="form.firstname"
          clearable
        />

        <v-text-field
          class="ml-12 mr-12"
          value="Doe"
          label="Last Name"
          prepend-inner-icon="mdi-account-edit"
          v-model="form.lastname"
          clearable
        />
      </div>
      <div class="form-inline">
        <v-text-field
          class="ml-12 mr-12"
          value="thomasdoe@gmail.com"
          label="Email Address"
          prepend-inner-icon="mdi-email-edit"
          v-model="form.contactinfo.email"
          clearable
        />

        <v-text-field
          class="ml-12 mr-12"
          value="9199978999"
          type="number"
          label="Mobile Number"
          prepend-inner-icon="mdi-phone-plus"
          v-model="form.contactinfo.mobilephone"
          clearable
        />
      </div>

      <template v-if="form && form.infoAddress && form.infoAddress.length > 0">
        <div v-for="(addr, i) in form.infoAddress" :key="i" class="address">
          <div class="title">
            {{ addr.addresstypecode === 'PRI' ? 'Primary' : 'Billing' }} Address
          </div>
          <v-row>
            <v-col md="6">
              <v-text-field
                label="Line 1"
                v-model="addr.address1"
                disabled
              />
            </v-col>
            <v-col md="6">
              <v-text-field
                label="Line 2"
                v-model="addr.address2"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="Street"
                v-model="addr.street"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="Zip Code"
                v-model="addr.zipcode"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="Area"
                v-model="addr.area"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="City"
                v-model="addr.city"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="District"
                v-model="addr.district"
                disabled
              />
            </v-col>
            <v-col md="4">
              <v-text-field
                label="State"
                v-model="addr.state"
                disabled
              />
            </v-col>
          </v-row>
        </div>
      </template>
     
      <v-card-actions>
      <v-row justify="center" class="mb-4">
          <v-btn
            class="login ml-4 mr-4 mb-2"
            rounded
            color="primary"
            @click="handleSubmit"
            v-if="!loading"
          >
            <v-icon left>mdi-update</v-icon>Update
          </v-btn>
          <v-progress-circular v-else indeterminate />
          <router-link to="/my-account">
            <v-btn
              class="login"
              outlined
              rounded
              color="primary"
            >
              <v-icon left>mdi-cancel</v-icon>Cancel
            </v-btn>
          </router-link>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { extractError } from '../../utils/error';
import { editInfo as editInfoService } from '../../services/profile';

export default {
  data() {
    return {
      loading: false,
      form: {
        contactinfo: {
          id: '',
          email: '',
          faxnbr: '',
          mobilephone: ''
        },
        firstname: '',
        lastname: '',
        middlename: '',
        infoAddress: []
      }
    }
  },
  computed: {
    ...mapState('auth', ['userInfo'])
  },
  methods: {
    async handleSubmit() {
      try {
        this.loading = true;
        const payload = {
          ...this.userInfo,
          contactinfo: {
            ...this.userInfo.contactinfo,
            ...this.form.contactinfo,
          }
        };
        payload.firstname = this.form.firstname;
        payload.lastname = this.form.lastname;
        payload.middlename = this.form.middlename;
        payload.infoAddress = this.form.infoAddress;
        // const result = await editInfoService(payload);
        await editInfoService(payload);
        // console.log('got result here ', JSON.parse(JSON.stringify(result)));
        this.loading = false;
        this.$toasted.success('Profile updated successfully', {
          duration: 2000
        });
      }
      catch(err) {
        this.loading = false;
        console.log(err);
        const message = extractError(err);
        this.$showError(message);
      }
    },
    setForm() {
      const { userInfo } = this;
      if(!userInfo) {
        return;
      }
      console.log('finally found you girl');
      const {
        contactinfo,
        firstname,
        lastname,
        middlename,
        infoAddress
      } = userInfo;
      this.form.contactinfo = contactinfo;
      this.form.firstname = firstname;
      this.form.lastname = lastname;
      this.form.middlename = middlename;
      this.form.infoAddress = infoAddress;
    }
  },
  watch: {
    userInfo() {
      this.setForm();
    }
  },
  mounted() {
    this.setForm();
  }
}
</script>

<style scoped>
  .address {
    padding: 50px;
  }
</style>